import { revisions as _revisions } from "../../standardAttachables.js";
import { reviseRiskRegister } from "./actions.js";

export const regRevisions = {
    ..._revisions,
    "headers": [_revisions.headers[0], _revisions.headers[1]],
    "actions": [{
        "label": "Revise Risk Register",
        "action": reviseRiskRegister
    }],
    "rowActions": [{
        "label": "Download",
        async action({ pageItem, rowItem, db }) {
            let url = await db.download(`Database/RiskReg/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.File}`);
            window.open(url, "fileView", "popup");
        }
    }]
};

export default [regRevisions];
